
import { throwError as observableThrowError, ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Logger } from '../logger.service';
import { map, catchError } from 'rxjs/operators';
// import { TokenInterceptor } from '../http/token.interceptor';
// import { AccessDto } from '../../access-config/common/access-dto';

const routes = {
    subFindSubscription: '/api/subFindSubscription',
    usrFindRegisteredUser: '/api/usrFindRegisteredUser',
    usrReadFinishUpCode: '/api/usrReadFinishUpCode',
    usrRequestAccess: '/api/usrRequestAccess'
    // //  apiCreateAccess: 'api/createAccess',
    //  apiListAccess: 'api/listAccess',
    //  apiSearchSubscriptions: '/api/searchSubscriptions',
};

const logger: Logger = new Logger('registeredUserService');

@Injectable({
    providedIn: 'root'
})
export class RegisteredUserService {

    constructor(private http: HttpClient) { }

    public findRegisteredUser(eMail: string): any {
        const email = eMail;  // TODO AccessDto.removePointFromEmail(eMail);
        const body = {
            eMail: email
        };
        return this.http.post<Response>(routes.usrFindRegisteredUser, body, { headers: new HttpHeaders({ 'Authorization': '' }) })
            .pipe(map((res: Response) => res), catchError((error: any) => {
                logger.error(error);
                return observableThrowError(() => error);
            }));
    }

    public findRegisteredUserPromise(eMail: string): Promise<any> {
        // const email = AccessDto.removePointFromEmail(eMail);
        const body = {
            eMail: eMail
        };
        // return this.http.post(routes.apiFindRegisteredUser, body, { cache: false, withCredentials: false }).toPromise()
        //   .then(res => res.json());
        return new Promise((resolve, reject) => {
            this.http.post(routes.usrFindRegisteredUser, body, { headers: new HttpHeaders({ 'Authorization': '' }) })
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res);
                    }
                ).catch((error) => {
                    reject(error);
                });
        });

    }

    public readFinishUpCode(eMail: string): any {
        const email = eMail;  // TODO AccessDto.removePointFromEmail(eMail);
        const body = {
            email: email
        };
        return this.http.post<Response>(routes.usrReadFinishUpCode, body, { headers: new HttpHeaders({ 'Authorization': '' }) })
            .pipe(map((res: Response) => res), catchError((error: any) => {
                logger.error(error);
                return observableThrowError(() => error);
            }));
    }

    public sendRequestAccess(email: string, requestDemo: boolean, finishUpCode: string): any {
        const date = new Date().getHours() + ':' + new Date().getMinutes() + ' del giorno ' + new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear();
        const body = {
            mailTo: email,
            demoFromStart: requestDemo,
            finishUpCode: finishUpCode,
            date: date
        };
        return this.http.post<Response>(routes.usrRequestAccess, body, { headers: new HttpHeaders({ 'Authorization': '' }) })
            .pipe(map((res: Response) => res), catchError((error: any) => {
                console.error(error);
                return observableThrowError(() => error);
            }));
    }

    public sendRequestAccessPromise(email: string, requestDemo: boolean, finishUpCode: string): Promise<any> {

        return this.sendRequestAccess(email, requestDemo, finishUpCode).toPromise();
    }


}
